/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAction } from 'redux-actions';
import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('parsers', [
  'getParsers',
  'getParser',
  'deleteParser',
  'addParser',
  'countParsers',
  'getParserCode',
  'getDebugResult',
]);

function getParsers(args) {
  return createAPIAction(
    types.getParsers,
    {
      endpoint: '/lora/parsers',
      query: args,
    },
  )();
}

function getParser(id) {
  return createAPIAction(
    types.getParser,
    {
      endpoint: `/lora/parsers/${id}`,
    },
  )();
}

function deleteParser(id) {
  return createAPIAction(
    types.deleteParser,
    {
      endpoint: `/lora/parsers/${id}`,
      method: 'DELETE',
    },
  )();
}

function addParser(data) {
  return createAPIAction(
    types.addParser,
    {
      endpoint: '/lora/parsers',
      method: 'POST',
      body: data,
    },
  )();
}

function countParsers(query) {
  return createAPIAction(
    types.countParsers,
    {
      endpoint: '/lora/parsers/count',
      query,
    },
  )();
}

export const getParserCode = createAction(types.getParserCode, c => c);

export const getDebugResult = createAction(types.getDebugResult, v => v);

export default {
  getParsers,
  getParser,
  deleteParser,
  addParser,
  countParsers,
  getParserCode,
  getDebugResult,
};




// WEBPACK FOOTER //
// ./src/redux/actions/parser.js